import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/item_categories',
    name: 'ItemCategory',
    component: {
      name: 'AdminItemCategory',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'item_category',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminItemCategoryIndex',
        component: () => import('../views/ItemCategoryIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminItemCategoryNew',
        component: () => import('../views/ItemCategoryInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminItemCategoryIndex' },
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminItemCategoryShow',
        component: () => import('../views/ItemCategoryShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminItemCategoryIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminItemCategoryDetails',
            component: () => import('../views/ItemCategoryDetails.vue'),
            meta: {
              backRoute: { name: 'AdminItemCategoryIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminItemCategoryEdit',
            component: () => import('../views/ItemCategoryInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminItemCategoryDetails' },
            },
          },
          {
            path: 'items',
            name: 'AdminItemCategoryItems',
            component: () => import('../views/item/ItemCategoryItems.vue'),
            meta: {
              backRoute: { name: 'AdminItemCategoryIndex' },
              resource: 'item',
            },
          },
          /* ------ Logs ------- */
          {
            path: 'logs',
            name: 'AdminItemCategoryLogs',
            component: () => import('../views/log/ItemCategoryLogs.vue'),
            meta: {
              backRoute: { name: 'AdminItemCategoryIndex', },
              resource: 'log',
            },
          },
        ],
      },
    ]
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));